export default {
	MeetingTopicsDialog_organizer_label: "Organizer:",
	MeetingTopicsDialog_team_label: "Assign Team",
	MeetingTopicsDialog_attendee_label: "Attendee",
	MeetingTopicsDialog_team_hint: "Assign a team to view and update team goals in the meeting center, and align meeting outcomes to the team",
	MeetingTopicsDialog_topicsList_header: "Meeting Topics",
	MeetingTopicsDialog_topicsRequestBtn_label: "Request Topics",
	MeetingTopicsDialog_topicsRequestBtn_explanation: "Request topics from attendees. You'll have the opportunity to arrange, edit, or remove added agenda topics.",
	MeetingTopicsDialog_topicsRequestSendEmailBtn_label: "Send Email",
	MeetingTopicsDialog_topicsRequestSent_label: "A request for topics has been sent.",
	MeetingTopicsDialog_topicsUpdate_label: "Update Topic",
	MeetingTopicsDialog_topicsUpdate_hint: "Enter - save changes              Esc - cancel",
	MeetingTopicsDialog_topicsList_label: "Topic(s)",
	MeetingTopicsDialog_topicsList_hint: "Hit 'enter' to add another topic, new lines will be treated as separate topics",
	MeetingTopicsDialog_assignedTeamLabel: "Assigned Team:",
};



// WEBPACK FOOTER //
// ./src/lang/en/meetingTopics.js